import Constant from '@/const'
import Store from '@/store/index.js'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // グループ取得
    get({ commit, dispatch }) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.GROUP}`,
        error: { message: 'グループ取得に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // グループ登録
    add({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.GROUP}`,
        params: data,
        error: { message: 'グループ登録に失敗しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // グループ登録
    edit({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.GROUP}/${data.ID}`,
        params: data,
        error: { message: 'グループ登録に失敗しました。' },
      }
      return dispatch('http/put', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // グループ登録
    delete({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.GROUP}/${data.ID}`,
        error: { message: 'グループ削除に失敗しました。' },
      }
      return dispatch('http/delete', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/group.js